export default "__VITE_ASSET__Bdx2U4QN__"